const filterButtons = Array.from(document.querySelectorAll<HTMLButtonElement>("[data-resource-filter]"));
const resourceCards = Array.from(document.querySelectorAll<HTMLElement>("[data-resource-card]"));
const resourceCount = document.querySelector<HTMLElement>("[data-resource-count]");
const resourceEmpty = document.querySelector<HTMLElement>("[data-resource-empty]");

for (const button of filterButtons) {
  button.addEventListener("click", () => {
    const filter = button.dataset.resourceFilter ?? "All";
    let visibleCount = 0;

    for (const candidate of filterButtons) {
      const isActive = candidate === button;
      candidate.classList.toggle("is-active", isActive);
      candidate.setAttribute("aria-pressed", String(isActive));
    }

    for (const card of resourceCards) {
      const isVisible = filter === "All" || card.dataset.category === filter;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    }

    if (resourceCount) {
      resourceCount.textContent = `${visibleCount} ${visibleCount === 1 ? "article" : "articles"}`;
    }
    if (resourceEmpty) resourceEmpty.hidden = visibleCount > 0;
  });
}

const copyLinkButton = document.querySelector<HTMLButtonElement>("[data-copy-link]");
copyLinkButton?.addEventListener("click", async () => {
  try {
    await navigator.clipboard.writeText(window.location.href);
    copyLinkButton.textContent = "Link copied";
    window.setTimeout(() => {
      copyLinkButton.textContent = "Copy link";
    }, 1800);
  } catch {
    copyLinkButton.textContent = "Copy unavailable";
  }
});

const progressBar = document.querySelector<HTMLElement>("[data-reading-progress]");
const updateReadingProgress = (): void => {
  if (!progressBar) return;
  const article = document.querySelector<HTMLElement>(".resource-article-body");
  if (!article) return;

  const start = article.offsetTop - window.innerHeight * 0.2;
  const distance = Math.max(article.offsetHeight - window.innerHeight * 0.55, 1);
  const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
  progressBar.style.transform = `scaleX(${progress})`;
};

if (progressBar) {
  updateReadingProgress();
  window.addEventListener("scroll", updateReadingProgress, { passive: true });
  window.addEventListener("resize", updateReadingProgress);
}
